// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContentLayout_wrapper__2WHSG"};